import { render, staticRenderFns } from "./printBagNumber.vue?vue&type=template&id=cfc1bd2a&scoped=true"
import script from "./printBagNumber.vue?vue&type=script&lang=js"
export * from "./printBagNumber.vue?vue&type=script&lang=js"
import style0 from "./printBagNumber.vue?vue&type=style&index=0&id=cfc1bd2a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc1bd2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfc1bd2a')) {
      api.createRecord('cfc1bd2a', component.options)
    } else {
      api.reload('cfc1bd2a', component.options)
    }
    module.hot.accept("./printBagNumber.vue?vue&type=template&id=cfc1bd2a&scoped=true", function () {
      api.rerender('cfc1bd2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/loadingDocument/printBagNumber.vue"
export default component.exports